import Vault from '../helpers/Vault';

class ApiDirector {
  constructor() {
    this.authToken = null;
  }

  fetch = (uri, init = {}, headers = { 'Content-Type': 'application/json' }) => {
    const authorizedHeaders = { ...headers };
    if (this.authToken && this.authToken !== 'managed') {
      authorizedHeaders.Authorization = this.authToken;
    }
    const base = init.uriBase || '/api/v1/';
    const blocking = typeof init.blocking !== 'undefined' ? init.blocking : true;
    Console.log(`${uri} blocking? ${blocking}`);
    const directedInit = {
      credentials: 'include',
      ...init,
      headers: authorizedHeaders,
      uriBase: undefined,
      blocking: undefined,
    };
    if (blocking) window.showLoading();
    Console.log(`fetch ${base}${uri}`);
    return fetch(`${base}${uri}`, directedInit).then((response) => {
      Console.log(`response ${base}${uri}`);
      if (blocking) window.hideLoading();
      if (response && response.status === 401) {
        // If the response is 401 not authorized this indicates
        // the vault may have a bad authToken.
        Vault.remove(Vault.keys.AUTH_TOKEN);
      }
      return response;
    });
  }

  imageUrl = (uri) => {
    const base = '/';
    if (uri) {
      return uri.startsWith('/system')
        ? `${base}${uri.substring(1)}`
        : `https:${uri}`;
    }
    return null;
  }

  redirectUrl = (uri) => {
    const base = '/';
    if (uri) {
      return uri.startsWith('/')
        ? `${base}${uri.substring(1)}`
        : `https:${uri}`;
    }
    return null;
  }

  setAuthToken = (authToken) => {
    this.authToken = authToken;
    Vault.store(Vault.keys.AUTH_TOKEN, authToken);
  }
}

const apiDirector = new ApiDirector();
export default apiDirector;
